export default {
  grade: {
    value: "F7",
    options: ["F7", "M5"],
  },
};
